import { render, staticRenderFns } from "./StatsBoard.vue?vue&type=template&id=b5763d32&scoped=true"
import script from "./StatsBoard.vue?vue&type=script&lang=js"
export * from "./StatsBoard.vue?vue&type=script&lang=js"
import style0 from "./StatsBoard.vue?vue&type=style&index=0&id=b5763d32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5763d32",
  null
  
)

export default component.exports